<template>
  <div style="background-color: #f4fbff; height: 100vh">
    <Header
      :leftArrow="true"
      :leftText="''"
      @leftClick="onClickLeft"
      :rightIcons="false"
    >
    </Header>
    <div class="login" v-show="stage != 4">
      <div class="login-wrap">
        <div class="login_id-pass" v-show="stage == 1">
          <div class="login_input-box two-fac">
            <p class="login_two-fac_title">ログインＩＤ入力</p>
            <p class="login_two-fac_ex">
              ログインIDを入力してください。
            </p>

            <div class="login_two-fac_select">
              <p class="login_two-fac_input-name">ログインＩＤ</p>
              <input
                type="email"
                id="two-fac_input"
                name="name"
                required
                value
                v-model="loginId"
              />
            </div>
          </div>
          <van-button
            block
            color="#3B82C4"
            type="primary"
            native-type="submit"
            :loading="loading"
            @click="returnPage"
            class="pwd_btn_lost"
          >戻る</van-button>
          <van-button
            style="margin-top: 20px"
            :disabled="!loginId"
            block
            :color="!loginId ? '#AACBE7' : '#3B82C4'"
            type="primary"
            native-type="submit"
            :loading="loading"
            @click="handleSure"
            class="pwd_btn_lost"
            >次へ</van-button>
        </div>
        <div class="login_id-pass" v-show="stage == 2">
          <div class="login_input-box two-fac">
            <p class="login_two-fac_title">メールアドレス入力</p>
            <p class="login_two-fac_ex">
              パスワード変更には認証が必要なため、メールアドレスを介し認証コードを送信します
            </p>

            <div class="login_two-fac_select">
              <p class="login_two-fac_input-name">メールアドレス</p>
              <input
                type="email"
                class="two-fac_input"
                name="name"
                required
                value
                v-model="mail"/>
            </div>
          </div>
          <van-button
              block
              color="#3B82C4"
              type="primary"
              native-type="submit"
              :loading="loading"
              @click="returnPage"
              class="pwd_btn_lost"
          >戻る</van-button>
          <van-button
            style="margin-top: 20px"
            :disabled="!mail"
            block
            :color="!mail ? '#AACBE7' : '#3B82C4'"
            type="primary"
            native-type="submit"
            :loading="loading"
            @click="sendMail"
            class="pwd_btn_lost">送信する
          </van-button>
        </div>

        <div class="login_id-pass" v-show="stage == 3">
          <div class="login_input-box two-fac">
            <p class="login_two-fac_title">認証コード入力</p>
            <p class="login_two-fac_ex">
              メールアドレス宛に認証コードを送信しました。<br />記載された6桁の数字を入力してください
            </p>

            <div class="login_two-fac_select">
              <p class="login_two-fac_input-name">認証コード</p>
              <input
                type="text"
                class="two-fac_input"
                name="name"
                required
                value
                v-model="verify_code"
              />
              <p class="login_id-pass_lost-txt">
                届かないので認証コードを<button
                style="color: #3f71a0"
                :style="{ color: this.canClick ? '#3f71a0' : 'gray' }"
                @click="sendAgain"
                :disabled="!canClick"
              >
                再送する
              </button>
              </p>
              <p class="login_id-pass_lost-txt" v-show="waitTimeShow">
                {{this.waitTime}}秒後に認証コードを再送することできます
              </p>
            </div>
          </div>
          <van-button
              block
              color="#3B82C4"
              type="primary"
              native-type="submit"
              :loading="loading"
              @click="returnPage"
              class="pwd_btn_lost"
          >戻る</van-button>
          <van-button
            style="margin-top: 20px"
            :disabled="!verify_code"
            block
            :color="!verify_code ? '#AACBE7' : '#3B82C4'"
            type="primary"
            native-type="submit"
            :loading="loading"
            @click="verifyCode"
            class="pwd_btn_lost"
            id="pwd_btn_lost_code">確認</van-button>
        </div>

      </div>
    </div>
    <div class="mypage mypage_change mypage_new-pass" v-show="stage == 4">
      <div class="wrap mypage_wrap">
        <div class="login_id-pass">
          <div class="login_input-box two-fac new-pass">
            <p class="login_two-fac_title">新しいパスワードを設定</p>
            <p class="login_two-fac_ex">パスワードは最低６文字以上です</p>
            <van-form style="width: 100%; max-width: 500px" ref="form">
              <p class="login_cont-name">新しいパスワード</p>
              <div class="login_pass-box">
                <input class="newPassword" name="newPassword" v-model="newPassword" maxlength="16"
                  :type="newPwdFlag ? 'password' : 'text'"/>
                <button class="btn_passview">
                  <img src="@/assets/img/login/pass.png"
                    :class="[this.newPwdFlag ? '' : 'img-opacity']" @click="changeNewPwd" alt="非表示"/>
                </button>
              </div>

              <p class="login_cont-name">新しいパスワード（確認用）</p>
              <div class="login_pass-box">
                <input class="confirmPasswd" name="confirmPasswd" v-model="confirmPasswd" maxlength="16"
                       :type="ConfirmpwdFlag ? 'password' : 'text'"/>
                <button class="btn_passview">
                  <img src="@/assets/img/login/pass.png" :class="[this.ConfirmpwdFlag ? '' : 'img-opacity']"
                    @click="changeConfirmpwd" alt="非表示"/>
                </button>
              </div>
            </van-form>
          </div>
          <van-button
              style="margin-top: 20px;"
              block
              color="#3B82C4"
              type="primary"
              native-type="submit"
              :loading="loading"
              @click="returnPage"
              class="pwd_btn_lost"
          >戻る</van-button>
          <van-button
              style="margin-top: 20px;"
              :disabled="!this.newPassword || !this.confirmPasswd"
              block
              :color="!this.newPassword || !this.confirmPasswd? '#AACBE7': '#3B82C4'"
              type="primary"
              native-type="submit"
              :loading="loading"
              @click="savePwd"
              id="mypage_btn_update_no_login"
            >設定する</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {CheckVerifyCode, UpdatePassword, VerifyLoginId, VerifyMail} from "@/services/login";
  import {Toast,Dialog} from "vant";
  import "vant/es/toast/style";
  import Header from "@/components/Header.vue";

  export default {
  data() {
    return {
      password: "",
      user: JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY)),
      loginId:'',
      loading: false,
      code:'',
      stage:1,
      mail:'',
      type:'',
      verify_code:'',
      canClick: true,
      waitTime: 60,
      waitTimeShow:false,
      newPwdFlag: true,
      ConfirmpwdFlag: true,
      newPassword:'',
      confirmPasswd:''
    };
  },
  components: {
    Header,
  },
  mounted() {
   this.code = this.$route.query.code;
  },
  methods: {
    onClickLeft() {
      history.back();
    },
    handleSure() {
      this.loading = true;
      const detail = {
        loginId:this.loginId,
        code:this.code
      }
      VerifyLoginId(detail).then((res) => {
        if (res.data.code >= 0) {
          this.type = res.data.data
          this.stage = 2
          this.loading = false
        } else {
          let error_msg = "ログインIDが正しくありません";
          Toast.fail(error_msg);
          this.loading = false;
        }
      });
    },
    returnPage(){
      this.$router.go(-1);
    },
    sendMail() {
      this.loading = true;
      const detail = {
        loginId:this.loginId,
        code:this.code,
        mail:this.mail,
        type:this.type
      }
      VerifyMail(detail).then((res) => {
        if (res.data.code >= 0) {
          this.stage = 3;
          this.loading = false
        } else {
          let error_msg = "メールアドレスが正しくありません";
          Toast.fail(error_msg);
          this.loading = false;
        }
      });
    },
    sendAgain() {
      this.verify_code = ''
      this.sendMail()
      this.canClick = false;
      this.waitTimeShow = true
      setTimeout(() => {
        this.canClick = true;
      }, 60000);
      let that = this
      that.waitTime--
      let timer = setInterval(function(){
        if(that.waitTime>1){
          that.waitTime--
        }else{
          clearInterval(timer)
          that.waitTime = 60
          that.waitTimeShow = false
        }
      },1000)
    },
    verifyCode() {
      this.loading = true;
      const detail = {
        loginId:this.loginId,
        code:this.code,
        mail:this.mail,
        type:this.type,
        verify_code:this.verify_code
      }
      CheckVerifyCode(detail).then((res) => {
        if (res.data.code >= 0) {
            this.stage = 4
            this.loading = false;
        } else {
          let error_msg = "認証コードが正しくありません";
          Toast.fail(error_msg);
          this.loading = false;
        }
      });
    },
    savePwd() {
      this.loading = true
      if(this.newPassword != this.confirmPasswd) {
        Toast("新しいパスワード一致していません");
        this.loading = false
        return
      }
      if(this.newPassword.length < 6) {
        Toast("パスワードは最低６文字以上です");
        this.loading = false
        return
      }
      const detail = {
        loginId:this.loginId,
        code:this.code,
        mail:this.mail,
        type:this.type,
        verify_code:this.verify_code,
        newPassword:this.newPassword
      }
      UpdatePassword(detail).then((res) => {
        if (res.data.code >= 0) {
          Dialog({ message: 'パスワードが変更されました。' });
          this.$router.push({
            path: "/login",
            query: {
              code: this.code,
            },
          });
        } else {
          let error_msg = "パスワードが変更できませんでした";
          Toast.fail(error_msg);
          this.loading = false
        }
      });
    },
    changeNewPwd(){
      this.newPwdFlag = !this.newPwdFlag;
    },
    changeConfirmpwd(){
      this.ConfirmpwdFlag = !this.ConfirmpwdFlag;
    },
  },
};
</script>

<style scoped>
   
.pwd_btn_lost {
  width: 100%;
  height: 54px;
  background: #aacbe7;
  border-radius: 8px;
  color: #fff;
  display: block;
  font-size: 20px;
  line-height: 54px;
  text-align: center;
  margin-top: auto;
}
.pwd_btn_lost.possible {
  background: #3b82c4;
  pointer-events: auto;
}

#mypage_btn_update_no_login {
  width: 100%;
  height: 54px;
  background: #aacbe7;
  border-radius: 8px;
  color: #fff;
  display: block;
  font-size: 20px;
  line-height: 54px;
  text-align: center;
  margin-top: 40px;
}
#mypage_btn_update_no_login.possible {
  background: #3b82c4;
  pointer-events: auto;
}
</style>
